import axios from 'axios'

import { type PitcherInfo } from '@lib/types/app'
import { type FileRetrieve, FileStatusEnum } from '@openapi'

const http = axios.create()
const POLLING_INTERVAL = 3500 // 3.5 seconds

export const getFileNameWithoutExtension = (fileNameWithExtension: string) =>
  fileNameWithExtension.replace(/\.[^/.]+$/, '')

export function getFileExtension(filename: string = '') {
  return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase()
}

export async function waitUntilFileViewable(id: FileRetrieve['id'], pitcherInfo: PitcherInfo): Promise<FileRetrieve> {
  return new Promise((resolve, reject) => {
    if (!id) return reject(new Error('File id is not provided'))
    if (!pitcherInfo) return reject(new Error('Pitcher info is not provided'))
    const { apiOrigin, accessToken } = pitcherInfo
    if (!apiOrigin) return reject(new Error('Pitcher api origin is not provided'))
    if (!accessToken) return reject(new Error('Pitcher access token is not provided'))

    const MAX_RETRIES = 3
    let retries = 0

    const checkFileStatus = () => {
      http
        .get<FileRetrieve>(`${apiOrigin}/api/v1/files/${id}/`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then(({ data }) => {
          if (data.status === FileStatusEnum.VIEWABLE) {
            resolve(data)
          } else {
            setTimeout(checkFileStatus, POLLING_INTERVAL)
          }
        })
        .catch((e) => {
          if (e.response && e.response.status === 404 && retries < MAX_RETRIES) {
            retries += 1
            setTimeout(checkFileStatus, POLLING_INTERVAL)
          } else {
            console.error(`Error while polling file status: ${e}`)
            reject(e)
          }
        })
    }

    checkFileStatus()
  })
}
